import { ParticipantForm } from '@/features/participants/components/ParticipantForm';
import { useParticipantForm } from '@/features/participants/hooks/useParticipantForm';
import { FormWrapper } from '@/shared/components/forms';
import { useTranslation } from 'react-i18next';

export const ParticipantEdit = () => {
  const form = useParticipantForm();
  const { t } = useTranslation();

  return (
    <FormWrapper form={form} title={t('pages.participants.edit.title')}>
      <ParticipantForm form={form} />
    </FormWrapper>
  );
};
